import * as cheerio from 'cheerio/slim';
import serialize from 'dom-serializer';
import escapeRegExp from 'lodash.escaperegexp';
import flatMap from 'lodash.flatmap';
import unescape from 'lodash.unescape';
import { isCheerioRootElement, isTagElement, isTextElement } from './util';
const loadDecoded = (html) => cheerio.load(html, { xml: { decodeEntities: true } }, false);
const EXCLUDE_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'aside', 'blockquote', 'figcaption'];
// Tml plugin to generate automatic linking
class Linkify {
    constructor({ linkifyUrls, itemPath, unescapeHtml, }) {
        this.linkifyUrls = [];
        this.regEpxBoundaries = '(?:\\b)';
        this.keywordMap = new Map();
        this.linkifyUrls = linkifyUrls;
        this.itemPath = itemPath;
        const pattern = [];
        this.linkifyUrls.forEach(({ keyword, url }) => {
            this.keywordMap.set(keyword, url);
            pattern.push(`${this.regEpxBoundaries}${escapeRegExp(keyword)}${this.regEpxBoundaries}`);
        });
        this._regex = new RegExp(pattern.join('|'), 'g');
        this.unescapeHtml = unescapeHtml;
    }
    get regex() {
        return this._regex;
    }
    updateTextNodes(node) {
        if (node?.data == null || node.data === '') {
            return node;
        }
        node.data = node.data.replace(this.regex, (match) => {
            const url = this.keywordMap.get(match);
            let updatedText = match;
            // casting to maintain legacy behavior
            const parentTag = node?.parent;
            let ancestorNode = node?.parent;
            let isAnchorDescendent = false;
            while (!isAnchorDescendent && ancestorNode != null) {
                // @ts-expect-error name prop might not exist
                isAnchorDescendent || (isAnchorDescendent = ancestorNode.name === 'a');
                ancestorNode = ancestorNode?.parent;
            }
            if (url != null &&
                url !== this.itemPath &&
                !isAnchorDescendent &&
                // a content item association is already a link, leave it alone
                !(isTagElement(parentTag) &&
                    parentTag?.name === 'span' &&
                    parentTag.attribs['tml-item-link'] !== undefined)) {
                updatedText = `<a href="${url}">${match}</a>`;
            }
            this.keywordMap.delete(match);
            return updatedText;
        });
        return node;
    }
    addLinks(el) {
        const childNodes = (isCheerioRootElement(el) ? el.children() : el?.children) ?? [];
        // using lodash flatmap because it works on iterables, and we might have
        // a Cheerio instead of an array
        const updatedNodes = flatMap(childNodes, (node) => {
            let updatedNode = node;
            if (isTagElement(node) && node.children.length && !EXCLUDE_TAGS.includes(node.name)) {
                this.addLinks(node);
            }
            else if (isTextElement(node) && node.data != null) {
                // casting to maintain legacy behavior
                const data = this.updateTextNodes(node).data ?? '';
                const parsed = loadDecoded(data);
                updatedNode = parsed.root().toArray()[0];
            }
            return updatedNode;
        });
        if (updatedNodes.length) {
            if (isCheerioRootElement(el)) {
                // casting to maintain legacy behavior
                el[0].children = updatedNodes;
            }
            else {
                el.children = updatedNodes;
            }
        }
        return el;
    }
    post(tmlResult) {
        if (!this.linkifyUrls.length) {
            return tmlResult;
        }
        // console.time('linkify');
        const $ = loadDecoded(tmlResult.html);
        tmlResult.html = serialize(this.addLinks($.root().children()));
        // console.timeEnd('linkify');
        if (this.unescapeHtml != null) {
            tmlResult.html = unescape(tmlResult.html);
        }
        return tmlResult;
    }
}
export default Linkify;
//# sourceMappingURL=linkify.js.map